<template>
  <el-dropdown @command="selectOps">
    <el-button v-if="showType === 'button'"
               class="operate-select">
      {{ buttonTitle }}
      <i class="jc-icon-caret-bottom jc-icon--right"></i>
    </el-button>
    <span v-else>
      {{ buttonTitle }}
      <i class="jc-icon-caret-bottom jc-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="(item, index) in operations"
                        :key="index"
                        :command="item"
                        :disabled="item.disabled"
                        class="jc-select-form-item"
                        :class="{'cps-dropdown-disabled': item.disabled}">
        <div v-if="item.disabled && item.tip !== ''" class="jc-form-tip">
          {{ item.tip }}
        </div>
        {{item.operateName}}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: 'DropdownOperation',
  props: {
    buttonTitle: {
      type: String,
      default: 'operation'
    },
    showType: {
      type: String,
      default: 'button'
    },
    operations: {
      type: Array,
      default: () => []
    },
    rowInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  methods: {
    selectOps(item) {
      if (!item.disabled) {
        this.$emit('clickSelectItem', item.value, this.rowInfo);
      }
    }
  },

};
</script>

<style lang="scss">
  @import "dropdown";
</style>



// WEBPACK FOOTER //
// src/components/privateNetInstance/dropdownOperation/DropdownOperation.vue